"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var alt_1 = require("../../alt");
var url_helpers_1 = require("../../shared/url_helpers");
var hash_util_1 = require("../../../reverb-js-common/hash_util");
var lodash_1 = require("lodash");
var I18n = require("i18n-js");
var core_client_1 = require("../../../lib/core_client");
var flash_1 = require("../../../flash");
var FollowListActionsBase = /** @class */ (function (_super) {
    tslib_1.__extends(FollowListActionsBase, _super);
    function FollowListActionsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FollowListActionsBase.prototype.fail = function () {
        return null;
    };
    FollowListActionsBase.prototype.loaded = function () {
        return null;
    };
    FollowListActionsBase.prototype.setFollows = function (response) {
        return response;
    };
    // pass in the follow to be removed in the store
    // in an ideal world the API would return the current
    // set of follows and we wouldn't need to infer the
    // current state
    FollowListActionsBase.prototype.removeFollow = function (follow) {
        return follow;
    };
    FollowListActionsBase.prototype.setArticleFollows = function (categories) {
        return categories;
    };
    FollowListActionsBase.prototype.updateArticleFollows = function (categories) {
        var _this = this;
        var req = core_client_1.default.post(url_helpers_1.default.articleFollowPath, { category_uuids: categories });
        req.catch(function () { return _this.fail(); });
        req.then(function () {
            flash_1.flashSuccess(I18n.t('discovery.feedCustomization.articleSaveNotice'));
            _this.setArticleFollows(categories);
        });
        return null;
    };
    FollowListActionsBase.prototype.deleteFollow = function (follow) {
        var _this = this;
        var req = core_client_1.default.destroy(hash_util_1.default.getLink(follow, 'self'));
        req.catch(function () { return _this.fail(); });
        req.then(function () { return _this.removeFollow(follow); });
        return null;
    };
    FollowListActionsBase.prototype.updateGearAlert = function (follow) {
        return follow;
    };
    FollowListActionsBase.prototype.fetch = function () {
        var _this = this;
        core_client_1.default.get(url_helpers_1.default.feedCustomizePath)
            .then(function (response) { return _this.setFollows(response); })
            .catch(function () { return _this.fail(); });
        return null;
    };
    FollowListActionsBase.prototype.addGearAlert = function (follow) {
        var _this = this;
        var req = core_client_1.default.post(hash_util_1.default.getLink(follow, 'alert'))
            .then(function (follow) { return _this.updateGearAlert(follow); });
        req.catch(function () { return _this.fail(); });
        return null;
    };
    FollowListActionsBase.prototype.removeGearAlert = function (follow) {
        var _this = this;
        var req = core_client_1.default.destroy(hash_util_1.default.getLink(follow, 'alert'))
            .then(function (follow) { return _this.updateGearAlert(follow); });
        req.catch(function () { return _this.fail(); });
        return null;
    };
    return FollowListActionsBase;
}(alt_1.AltActions));
exports.FollowListActions = alt_1.default.createActions(FollowListActionsBase);
var FollowListStoreBase = /** @class */ (function (_super) {
    tslib_1.__extends(FollowListStoreBase, _super);
    function FollowListStoreBase() {
        var _this = _super.call(this) || this;
        _this.follow_groups = [];
        _this.loaded = false;
        _this.current_page = null;
        _this.total = null;
        _this.total_pages = null;
        _this.article_follows = [];
        _this.bindActions(exports.FollowListActions);
        return _this;
    }
    FollowListStoreBase.prototype.onSetFollows = function (response) {
        this.setState(tslib_1.__assign({ loaded: true }, response));
    };
    FollowListStoreBase.prototype.onSetArticleFollows = function (categories) {
        this.setState({
            article_follows: categories,
        });
    };
    FollowListStoreBase.prototype.onRemoveFollow = function (follow) {
        var followGroups = this.follow_groups;
        followGroups.forEach(function (group) {
            var follows = lodash_1.reject(group.follows, function (f) { return f === follow; });
            group.follows = follows;
        });
        this.setState({ follow_groups: followGroups });
    };
    FollowListStoreBase.prototype.onFail = function () {
        this.setState({ loaded: true });
    };
    FollowListStoreBase.prototype.onLoaded = function () {
        this.setState({ loaded: true });
    };
    FollowListStoreBase.prototype.onUpdateGearAlert = function (follow) {
        var followGroups = this.follow_groups;
        followGroups.forEach(function (group) {
            var follows = group.follows.map(function (f) {
                if (f._links.self.href === follow._links.self.href) {
                    return follow;
                }
                return f;
            });
            group.follows = follows;
        });
        this.setState({ follow_groups: followGroups });
    };
    return FollowListStoreBase;
}(alt_1.AltStoreModel));
exports.FollowListStore = alt_1.default.createStore(FollowListStoreBase, 'FollowListStore');
//# sourceMappingURL=follow_list_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/follow_list_store.js
// module id = 6xjI
// module chunks = 20 21